type Props = {
  label: string;
  value: string | number;
  hint?: string;
  tone?: 'default' | 'warn' | 'good';
};

export default function KpiCard({ label, value, hint, tone = 'default' }: Props) {
  const toneClass =
    tone === 'warn'
      ? 'text-amber-700'
      : tone === 'good'
        ? 'text-emerald-700'
        : 'text-slate-900';
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="text-xs uppercase tracking-wide text-slate-500">{label}</div>
      <div className={`mt-1 text-2xl font-semibold ${toneClass}`}>{value}</div>
      {hint && <div className="mt-1 text-xs text-slate-500">{hint}</div>}
    </div>
  );
}
